import React from 'react'
import { useSelector } from 'react-redux'
import validationConfig from './validationConfig'
import CustomCollapse from '../../CustomCollapse'
import CheckIcon from '../../../../assets/icons/check-icon.svg'
import ErrorIcon from '../../../../assets/icons/exclamation-icon.svg'
import FormValidators from '../../../../helpers/FormValidators'
import { MultiSelectField } from '../../FormFields'
import ScopeTypes from '../../../../constants/ScopeTypes'
import MandatoryScopes from '../../../../constants/MandatoryScopes'

const ApplicationAccessForm = ({ formState, appId, disabled }) => {
  // ===== Form state =====
  const { formData, formErrors, onFormDataChanged, validateFormField } = formState

  // ===== Redux state =====
  const allApiResources = useSelector(({ lookupData }) => lookupData.allApiResources)

  //  ===== Methods =====
  const onChange = (key, value) => {
    if (key === "applicationScopes") {
      value = value?.map(val => ({
        ...val, 
        type: ScopeTypes.ROLE, 
        applicationId: appId
      }))
    }
    onFormDataChanged(key, value)
    validateFormField(key, value, validationConfig)
  }

  return (
    <CustomCollapse
      title="Application Access"
      description="These are the roles and scopes of your application"
      icon={FormValidators.checkFormValidity(formErrors, validationConfig) ? CheckIcon : ErrorIcon}
    >
      <MultiSelectField
        displayName="Roles"
        placeholder="Select application roles"
        onChange={(value) => onChange("applicationScopes", value)}
        errorMessage={formErrors["applicationScopes"]?.message}
        options={Array.isArray(allApiResources) ? allApiResources : []}
        value={formData["applicationScopes"]}
        disabled={disabled}
      />
      {/* This field is hardcoded just to show the Appframework Scope */}
      <MultiSelectField
        displayName="Scopes"
        placeholder="Application Scopes"
        options={[]}
        disabled={true}
        value={[{ value: MandatoryScopes.APPFRAMEWORK }]}
      />
    </CustomCollapse>
  )
}

export default ApplicationAccessForm
